import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export async function fetchScanConfig() {
    const { data } = await apiClient.get("/scan/config");
    return data;
}

export async function submitScan({ context, answers }) {
    const { data } = await apiClient.post("/scan/submit", { context, answers });
    return data;
}

export async function fetchScanResult(id) {
    const { data } = await apiClient.get(`/scan/result/${id}`);
    return data;
}

export async function submitContact(payload) {
    const { data } = await apiClient.post("/contact", payload);
    return data;
}

export async function adminLogin(password) {
    const { data } = await apiClient.post(
        "/admin/login",
        {},
        { headers: { "X-Admin-Password": password } },
    );
    return data;
}

export async function fetchAdminContacts(password) {
    const { data } = await apiClient.get("/admin/contacts", {
        headers: { "X-Admin-Password": password },
    });
    return data;
}

export async function fetchAdminSubmissions(password) {
    const { data } = await apiClient.get("/admin/submissions", {
        headers: { "X-Admin-Password": password },
    });
    return data;
}

export async function fetchAdminAnalytics(password) {
    const { data } = await apiClient.get("/admin/analytics", {
        headers: { "X-Admin-Password": password },
    });
    return data;
}

// Fire-and-forget analytics. Never throws, never blocks the UI.
export function trackEvent(type, { submissionId = null, meta = null } = {}) {
    try {
        apiClient
            .post("/events", { type, submission_id: submissionId, meta })
            .catch(() => {});
    } catch (e) {
        console.error("trackEvent failed:", e);
    }
}

